import 'moment/locale/en-gb';
import 'moment/locale/hu';
import 'moment/locale/ro';

import { enGB } from 'date-fns/locale/en-GB';
import { hu } from 'date-fns/locale/hu';
import { ro } from 'date-fns/locale/ro';
import { LanguageEnum } from 'gleblu-socket-api';
import { registerLocale } from 'react-datepicker';

import Language from './Language';

const english: Language = {
  languageEnum: LanguageEnum.ENGLISH,
  displayName: 'English',
  shortLocale: 'en',
  locale: 'en-GB',
  messengerLocale: 'en_GB',
};
const romanian: Language = {
  languageEnum: LanguageEnum.ROMANIAN,
  displayName: 'Română',
  shortLocale: 'ro',
  locale: 'ro',
  messengerLocale: 'ro_RO',
};
const hungarian: Language = {
  languageEnum: LanguageEnum.HUNGARIAN,
  displayName: 'Magyar',
  shortLocale: 'hu',
  locale: 'hu',
  messengerLocale: 'hu_HU',
};

const languages = { english, romanian, hungarian };

registerLocale(english.locale, enGB);
registerLocale(romanian.locale, ro);
registerLocale(hungarian.locale, hu);

export default languages;

export function getBrowserLanguage(): LanguageEnum | null {
  const languageCode: string =
    navigator.language || (navigator.languages && navigator.languages[0]) || (navigator as any).browserLanguage || (navigator as any).userLanguage;
  const language = languageCode.split('-')[0];

  const browserLanguage = Object.keys(languages)
    .filter((key) => (languages[key] as Language).locale.startsWith(language))
    .map((key) => (languages[key] as Language).languageEnum);

  if (browserLanguage && browserLanguage.length > 0) return browserLanguage[0];
  return null;
}
